<template>
  <b-modal ref="route-modal" id="modal-center-routes" hide-footer>
    <template v-slot:modal-header>
     <b-row style="width:100%;">
        <h5 style="margin-left:5%;margin-top:10px">{{ $t('message.select_route') }}</h5>
        <b-button class="ml-auto" :disabled="showLoader" type="submit" variant="link" @click="addRoute">
            <b-spinner v-if="showLoader" label="Spinning"></b-spinner>
            {{ $t('message.Done') }}
        </b-button>
     </b-row>
    </template>
    <template class="route-modal-body" v-slot:default>
      <b-input-group size="sm" class="mb-2" style="height:48px;">
        <b-input-group-prepend is-text style="height:48px;">
          <b-icon icon="square-fill" variant="info" font-scale="0.5"></b-icon>
        </b-input-group-prepend>
        <b-form-input style="height:48px;" v-model="loadingCity" @input="searchLoading" :value="loadingCity" type="search" :placeholder="$t('message.loadig_city')"></b-form-input>
      </b-input-group>
      <b-input-group size="sm" class="mb-2" style="height:48px;">
        <b-input-group-prepend is-text style="height:48px;">
          <b-icon icon="square-fill" variant="secondary" font-scale="0.5"></b-icon>
        </b-input-group-prepend>
        <b-form-input style="height:48px;" v-model="unLoadingCity" @input="searchUnLoading" :value="unLoadingCity" type="search" :placeholder="$t('message.unLoading_city')"></b-form-input>
      </b-input-group>
      <template v-if="searchOptions.length>0" class="route-select-body">
        <b-list-group>
          <div v-for="(searchValue,index) in searchOptions" v-bind:key="'searchValue'+index">
            <b-list-group-item @click="selectedRoute(index)">{{searchOptions[index].text}}</b-list-group-item>
          </div>
        </b-list-group>
      </template>
      <template v-if="preferredRoutesList.length>0 && searchOptions.length ===0" class="route-select-body">
        <div style="margin-top:10px;margin-bottom:10px">
          <h7>{{ $t('message.preferred_routes') }}</h7>
        </div>
        <b-list-group>
          <div v-for="(preferredRoute,index) in preferredRoutesList" v-bind:key="'preferredRoute'+index">
            <b-list-group-item @click="selectedPreferredRoute(index)">
              <b-row>
                <b-col cols="5">
                  <b-form-text>{{preferredRoutesList[index].origin}}</b-form-text>
                </b-col>
                <b-col cols="1">
                  <b-icon icon="arrow-left-right" variant="secondary" font-scale="1"></b-icon>
                </b-col>
                <b-col cols="5">
                  <b-form-text>{{preferredRoutesList[index].destination}}</b-form-text>
                </b-col>
              </b-row>
            </b-list-group-item>
          </div>
        </b-list-group>
      </template>
      <div v-if="searchResultNotFound">
        <NoresultsFound/>
      </div>
    </template>
  </b-modal>
</template>

<script>
//import {ModelSelect} from 'vue-search-select'
import axios from "axios";
const commonUtil = require('../../util/commonUtil');
import NoresultsFound from './NoresultsFound.vue';
import {MX_TRACK} from '../../utils/Mixpanel';
import config from '../../config/config';
export default {
  props: {
    routes_list: [Array, Object],
    type: String
  },
  name: 'RouteModal',
  data() {
    return {
      showLoader: false,
      searchingOrigin:false,
      searchingDestination:false,
      searchResultNotFound:false,
      searchOptions:[],
      loadingCity:'',
      unLoadingCity:'',
      loadingPointOptions: [],
      preferredRoutesList:[],
      loadingPoints: [],
      loadingPoint: {
        value: '',
        text: ''
      },
      unLoadingPointOptions: [],
      unLoadingPoints: [],
      unLoadingPoint: {
        value: '',
        text: ''
      },
    }
  },
  components: {
    NoresultsFound
  },
  computed: {
    // isLoadingPoint() {
    //   return this.$v.loadingPoint.value.$dirty ? this.$v.loadingPoint.value.$error : null;
    // },
    // isUnloadingPoint() {
    //   return this.$v.unLoadingPoint.value.$dirty ? this.$v.unLoadingPoint.value.$error : null;
    // }
  },
  methods: {
    selectedPreferredRoute(index){
      //alert("index"+index)
      this.showLoader = true;
      const body = {
        origin: this.preferredRoutesList[index].origin,
        origin_place_id: this.preferredRoutesList[index].origin_place_id,
        origin_terms: this.preferredRoutesList[index].origin_terms,
        destination: this.preferredRoutesList[index].destination,
        destination_place_id: this.preferredRoutesList[index].destination_place_id,
        destination_terms: this.preferredRoutesList[index].destination_terms,
      }
      this.loadingCity=this.preferredRoutesList[index].origin
      this.unLoadingCity=this.preferredRoutesList[index].destination
      this.loadingPoint= {
          value: this.preferredRoutesList[index].origin_place_id,
          text: this.preferredRoutesList[index].origin
        }
      this.unLoadingPoint= {
          value: this.preferredRoutesList[index].destination_place_id,
          text: this.preferredRoutesList[index].destination
        }
      const mxData = {
            origin: this.loadingPoint.text,
            destination: this.unLoadingPoint.text
          }
          this.trackMixpanelEvent(config.MIXPANEL_EVENTS.SEARCH_PREFERRED_ROUTE, mxData)
      this.$emit('add-route', body)
      this.$refs['route-modal'].hide()
      this.showLoader = false;
      //this.clear();
    },
    async selectedRoute(index){
      if(this.searchingOrigin){
        this.loadingPoint= {
          value: this.searchOptions[index].value,
          text: this.searchOptions[index].text
        }
        this.loadingCity = this.searchOptions[index].text
        const mxData = {
            origin: this.loadingPoint.text,
            destination: this.unLoadingPoint.text
          }
          this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ADD_ORIGIN_POINT_FOR_SEARCH, mxData)
        this.searchOptions = []
      }else{
        this.unLoadingPoint= {
          value: this.searchOptions[index].value,
          text: this.searchOptions[index].text
        }
        this.unLoadingCity = this.searchOptions[index].text
        const mxData = {
            origin: this.loadingPoint.text,
            destination: this.unLoadingPoint.text
          }
          this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ADD_DESTINATION_POINT_FOR_SEARCH, mxData)
        this.searchOptions = []
        if(this.loadingCity!==''){
          this.addRoute();
        }
      }
    },
    async clear() {
      this.loadingPointOptions= [],
      this.loadingPoints= [],
      this.loadingPoint= {
        value: '',
        text: ''
      },
      this.unLoadingPointOptions= [],
      this.unLoadingPoints= [],
      this.unLoadingPoint= {
        value: '',
        text: ''
      },
      this.loadingCity='',
      this.unLoadingCity=''
    },
    async addRoute() {
        this.showLoader = true;
        const body = {
          origin: this.loadingPoint.text,
          origin_place_id: this.loadingPoint.value,
          origin_terms: commonUtil.getPointTerms(this.loadingPoints, this.loadingPoint, this.type),
          destination: this.unLoadingPoint.text,
          destination_place_id: this.unLoadingPoint.value,
          destination_terms: commonUtil.getPointTerms(this.unLoadingPoints, this.unLoadingPoint, this.type),
        }
        const mxData = {
            origin: this.loadingPoint.text,
            destination: this.unLoadingPoint.text
          }
          this.trackMixpanelEvent(config.MIXPANEL_EVENTS.SEARCH_QUERY_MADE, mxData)
       this.$emit('add-route', body)
        this.$refs['route-modal'].hide()
       // this.clear();
        this.showLoader = false;
     // }
    },
    async searchLoading(text) {
      this.loadingCity = text;
      this.searchingOrigin = true;
      this.searchingDestination = false;
      if (text) {
        const {data} = await axios.get(`/place/autocomplete?input=${text}`)
        this.loadingPointOptions = [];
        this.loadingPoints = [];
        this.searchOptions = [];
        const list = data.data.predictions;
        if(list.length>0){
          this.searchResultNotFound = false
          for (let i = 0; list && i < list.length; i++) {
            this.loadingPointOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.searchOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.loadingPoints.push(list[i])
          }
        }else{
          this.searchResultNotFound = true
          this.loadingPoint= {
            value: '',
            text: ''
          }
        }
      }else{
        this.loadingPointOptions = [];
        this.loadingPoints = [];
        this.searchOptions = [];
        this.loadingPoint= {
          value: '',
          text: ''
        }
        this.searchResultNotFound = false;
      }
    },
    trackMixpanelEvent(event, data = {}) {
        const demandDetails = this.$store.getters.getDemandDetails.value
        const mx_prop = {
          time: new Date().getTime(),
          page_src: this.$route.name,
          user_type: demandDetails.user_type,
          user_name: demandDetails.supplier_name,
          phone_number: demandDetails.contact,
          language: this.$route.params.lang,
          demand_id: demandDetails.demand_id,
          bid_status: demandDetails.status,
        }
        MX_TRACK(event, {...mx_prop, ...data})
    },
    async searchUnLoading(text) {
      this.unLoadingCity = text;
      this.searchingOrigin = false;
      this.searchingDestination = true;
      if (text) {
        const {data} = await axios.get(`place/autocomplete?input=${text}`)
        this.unLoadingPointOptions = [];
        this.unLoadingPoints = [];
        this.searchOptions = [];
        const list = data.data.predictions;
        if(list.length>0){
          this.searchResultNotFound = false
          for (let i = 0; list && i < list.length; i++) {
            this.unLoadingPointOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.searchOptions.push({value: '' + list[i].place_id, text: list[i].description})
            this.unLoadingPoints.push(list[i])
          }
        }else{
          this.searchResultNotFound = true
          this.unLoadingPoint= {
            value: '',
            text: ''
          }
        }
      }else{
        this.searchOptions = [];
        this.unLoadingPointOptions = [];
        this.unLoadingPoints = [];
        this.unLoadingPoint= {
          value: '',
          text: ''
        }
        this.searchResultNotFound = false;
      }
    },
    async routes(){
      // if(this.routes_list.length>0){
      //   this.routes_list.map((route,index)=>{
      //     this.unLoadingPointOptions[index].options = route.unLoadingPointOptions
      //     this.loadingPoint ={
      //       value: route.origin_place_id,
      //       text: route.origin,
      //     }
      //     this.unLoadingPoint ={
      //       value: route.destination_place_id,
      //       text: route.destination,
      //     }
      //   })
      // }
      // else{
      //   this.loadingPoint = {
      //     value: '',
      //     text: ''
      //   };
      //   this.unLoadingPoint = [{
      //     value: '',
      //     text: '',
      //   }]
      // }
    },
    async preferredRoutes(){
      let demandId = this.$route.params.id;
      const {data} = await axios.get(`supplier_routes/${demandId}/list`)
      this.preferredRoutesList=data.value
    },
  },
  async mounted() {
    this.$root.$on('on-add-route', async () => {
      if (this.type == "multiple") {
        await this.preferredRoutes();
      }
      await this.routes();
      this.$root.$emit('bv::show::modal', 'modal-center-routes')
    });
  }
}
</script>
<style lang="scss">
// .modal-content {
//     border-radius: 4px !important;
//     min-height: 600px;
//     max-height: 700px;
// }
.input-group-text {
  background-color: #fff;
  border-right-color:#fff;
}
.list-group {
  max-height: 300px;
  min-height: 300px;
  overflow: auto;
}
// .modal-body {
//   overflow: auto;
// }
</style>
